import logger from '@/utils/logger';
import ApiService from '@/services/api.service';
import uiModeService from '@/utils/uiMode.service';
import pageWindowNavigationService from '@/utils/pageWindowNavigation.service';
import {
  DEFAULT_UI_PREFERENCES,
  getCachedUIPreferences,
  cacheUIPreferences,
  normalizeUIPreferences,
} from '@/utils/uiPreferences.storage';

const EVENT_NAME = 'uiPreferencesChanged';

class UIPreferencesService {
  getDefaults() {
    return { ...DEFAULT_UI_PREFERENCES };
  }

  getCached() {
    return getCachedUIPreferences();
  }

  cacheLocally(preferences) {
    return cacheUIPreferences(preferences);
  }

  apply(preferences) {
    const normalized = normalizeUIPreferences(preferences);

    try {
      uiModeService.applyMode(normalized.uiMode);
      pageWindowNavigationService.applyMode(normalized.pageWindowMode);
      cacheUIPreferences(normalized);

      window.dispatchEvent(new CustomEvent(EVENT_NAME, {
        detail: { preferences: normalized },
      }));
    } catch (error) {
      logger.error('Error applying UI preferences:', error);
    }

    return normalized;
  }

  applyCached() {
    return this.apply(this.getCached());
  }

  async fetchPreferences(companyId) {
    const response = await ApiService.get(`/company/${companyId}/ui-preferences`);
    const data = response?.data?.data || response?.data || {};
    const normalized = normalizeUIPreferences(data);
    cacheUIPreferences(normalized);
    return normalized;
  }

  async savePreferences(companyId, preferences) {
    const payload = normalizeUIPreferences(preferences);
    const response = await ApiService.put(`/company/${companyId}/ui-preferences`, payload);
    const data = response?.data?.data || response?.data || payload;
    const normalized = normalizeUIPreferences(data);
    return this.apply(normalized);
  }

  getAvailableUiModes() {
    return uiModeService.getAvailableModes();
  }

  getAvailablePageWindowModes() {
    return pageWindowNavigationService.getAvailableModes();
  }

  getPreviewStyle(mode) {
    return uiModeService.getPreviewStyle(mode);
  }
}

export default new UIPreferencesService();
